<template>
  <div
    v-editable="blok"
    :class="blok.image?.filename ? 'background-image' : 'without-image'"
    class="page-header"
  >
    <img
      :src="blok.image?.filename"
      :alt="blok.image?.alt || ''"
      v-if="blok.image?.filename"
      class="page-header-image"
    />
    <div class="page-header-text">
      <h1>{{ blok.title }}</h1>
      <h3>{{ blok.subtitle }}</h3>
    </div>
  </div>
</template>

<script setup lang="ts">
import { StoryblokPageHeaderBlok } from '@/features/storyblok/types';

const props = defineProps<{
  blok: StoryblokPageHeaderBlok;
}>();
</script>

<style scoped>
.page-header {
  background: var(--ion-background-color);
  color: var(--ion-color-primary);
}
.without-image {
  display: flex;
  flex-direction: column;
}
.background-image {
  display: grid;
}
.page-header-text {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  color: var(--ion-text-color);
}
.page-header-image {
  grid-row: 1 / 2;
  grid-column: 1 / 2;
  object-fit: contain;
  border-radius: 8px;
  justify-self: center;
  align-self: center;
}
</style>
